// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Segoe UI", Roboto, system-ui, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

* {
  scrollbar-color: initial;
  scrollbar-width: initial;
}
  :root {
    font-size: clamp(9.0px, 0.6vw + 0.45rem, 10px);
  }

  /* Laptop screens: 1025px–1440px */
  @media (min-width: 1025px) and (max-width: 1440px) {
    :root {
      font-size: clamp(11px, 0.75vw + 0.5rem, 12.5px);
    }
  }
  
  /* Big screens: 1441px+ */
  @media (min-width: 1441px) {
    :root {
      font-size: clamp(12px, 0.8vw + 0.5rem, 13.5px);
    }
  }

  @supports (font: -apple-system-body) {
    body {
      -webkit-font-smoothing: antialiased;
      text-rendering: optimizeLegibility;
      font-synthesis: none;
    }
  }

  /* Mobile-first adjustments */
  @media (max-width: 640px) {
    :root {
      font-size: clamp(12px, 0.7vw + 13px, 13px);
    }
  }

  /* High-DPI optimization */
  @media (-webkit-device-pixel-ratio: 1.25) {
    :root {
      font-size: clamp(10.5px, 0.75vw + 0.5rem, 12px);
    }
  }
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 360px) {

  .\\!container {
    max-width: 360px !important;
  }

  .container {
    max-width: 360px;
  }
}
@media (min-width: 640px) {

  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .\\!container {
    max-width: 1024px !important;
  }

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .\\!container {
    max-width: 1280px !important;
  }

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1440px) {

  .\\!container {
    max-width: 1440px !important;
  }

  .container {
    max-width: 1440px;
  }
}
@media (min-width: 1600px) {

  .\\!container {
    max-width: 1600px !important;
  }

  .container {
    max-width: 1600px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-\\[8px\\] {
  bottom: -8px;
}
.-top-2 {
  top: -0.5rem;
}
.-top-3 {
  top: -0.75rem;
}
.-top-px {
  top: -1px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-20 {
  bottom: 5rem;
}
.bottom-28 {
  bottom: 7rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-8 {
  bottom: 2rem;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-0\\.5 {
  left: 0.125rem;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\.5 {
  left: 0.375rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-6 {
  left: 1.5rem;
}
.left-\\[25\\%\\] {
  left: 25%;
}
.left-\\[75\\%\\] {
  left: 75%;
}
.left-\\[80px\\] {
  left: 80px;
}
.left-fluid-2 {
  left: clamp(0.625rem, 0.6vw, 0.875rem);
}
.left-full {
  left: 100%;
}
.right-0 {
  right: 0px;
}
.right-16 {
  right: 4rem;
}
.right-2 {
  right: 0.5rem;
}
.right-20 {
  right: 5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-8 {
  right: 2rem;
}
.right-\\[-12px\\] {
  right: -12px;
}
.right-fluid-1 {
  right: clamp(0.300rem, 0.1vw, 0.350rem);
}
.right-fluid-2 {
  right: clamp(0.625rem, 0.6vw, 0.875rem);
}
.top-0 {
  top: 0px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-6 {
  top: 1.5rem;
}
.top-8 {
  top: 2rem;
}
.top-9 {
  top: 2.25rem;
}
.top-\\[120\\%\\] {
  top: 120%;
}
.top-\\[calc\\(100\\%\\+0\\.5rem\\)\\] {
  top: calc(100% + 0.5rem);
}
.top-\\[calc\\(100\\%\\+1rem\\)\\] {
  top: calc(100% + 1rem);
}
.top-\\[calc\\(100\\%\\+8px\\)\\] {
  top: calc(100% + 8px);
}
.top-full {
  top: 100%;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[10000\\] {
  z-index: 10000;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[1001\\] {
  z-index: 1001;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[10\\] {
  z-index: 10;
}
.z-\\[1100\\] {
  z-index: 1100;
}
.z-\\[1200\\] {
  z-index: 1200;
}
.z-\\[1400\\] {
  z-index: 1400;
}
.z-\\[1500\\] {
  z-index: 1500;
}
.z-\\[190\\] {
  z-index: 190;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[2000\\] {
  z-index: 2000;
}
.z-\\[200\\] {
  z-index: 200;
}
.z-\\[20\\] {
  z-index: 20;
}
.z-\\[210\\] {
  z-index: 210;
}
.z-\\[301\\] {
  z-index: 301;
}
.z-\\[350\\] {
  z-index: 350;
}
.z-\\[400\\] {
  z-index: 400;
}
.z-\\[401\\] {
  z-index: 401;
}
.z-\\[5000\\] {
  z-index: 5000;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[70\\] {
  z-index: 70;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[999\\] {
  z-index: 999;
}
.z-\\[9\\] {
  z-index: 9;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-5 {
  grid-column: span 5 / span 5;
}
.col-span-full {
  grid-column: 1 / -1;
}
.m-0 {
  margin: 0px;
}
.-mx-fluid-3 {
  margin-left: calc(clamp(0.875rem, 0.9vw, 1.25rem) * -1);
  margin-right: calc(clamp(0.875rem, 0.9vw, 1.25rem) * -1);
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-fluid-1 {
  margin-top: clamp(0.300rem, 0.1vw, 0.350rem);
  margin-bottom: clamp(0.300rem, 0.1vw, 0.350rem);
}
.my-fluid-2 {
  margin-top: clamp(0.625rem, 0.6vw, 0.875rem);
  margin-bottom: clamp(0.625rem, 0.6vw, 0.875rem);
}
.my-fluid-3 {
  margin-top: clamp(0.875rem, 0.9vw, 1.25rem);
  margin-bottom: clamp(0.875rem, 0.9vw, 1.25rem);
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-mt-\\[3\\.2rem\\] {
  margin-top: -3.2rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-fluid-0\\.5 {
  margin-bottom: clamp(0.15rem, 0.12vw, 0.350rem);
}
.mb-fluid-1 {
  margin-bottom: clamp(0.300rem, 0.1vw, 0.350rem);
}
.mb-fluid-2 {
  margin-bottom: clamp(0.625rem, 0.6vw, 0.875rem);
}
.mb-fluid-3 {
  margin-bottom: clamp(0.875rem, 0.9vw, 1.25rem);
}
.mb-fluid-4 {
  margin-bottom: clamp(1.5rem, 2.5vw, 2.5rem);
}
.ml-0 {
  margin-left: 0px;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-\\[2\\] {
  margin-left: 2;
}
.ml-\\[6px\\] {
  margin-left: 6px;
}
.ml-auto {
  margin-left: auto;
}
.ml-fluid-0\\.5 {
  margin-left: clamp(0.15rem, 0.12vw, 0.350rem);
}
.ml-fluid-1 {
  margin-left: clamp(0.300rem, 0.1vw, 0.350rem);
}
.ml-fluid-2 {
  margin-left: clamp(0.625rem, 0.6vw, 0.875rem);
}
.ml-fluid-3 {
  margin-left: clamp(0.875rem, 0.9vw, 1.25rem);
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-fluid-1 {
  margin-right: clamp(0.300rem, 0.1vw, 0.350rem);
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-\\[1px\\] {
  margin-top: 1px;
}
.mt-auto {
  margin-top: auto;
}
.mt-fluid-0\\.5 {
  margin-top: clamp(0.15rem, 0.12vw, 0.350rem);
}
.mt-fluid-1 {
  margin-top: clamp(0.300rem, 0.1vw, 0.350rem);
}
.mt-fluid-1\\.5 {
  margin-top: clamp(0.550rem, 0.480vw, 0.7rem);
}
.mt-fluid-2 {
  margin-top: clamp(0.625rem, 0.6vw, 0.875rem);
}
.mt-fluid-3 {
  margin-top: clamp(0.875rem, 0.9vw, 1.25rem);
}
.mt-fluid-4 {
  margin-top: clamp(1.5rem, 2.5vw, 2.5rem);
}
.box-border {
  box-sizing: border-box;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.h-0 {
  height: 0px;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-44 {
  height: 11rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[1\\.2em\\] {
  height: 1.2em;
}
.h-\\[1\\.8rem\\] {
  height: 1.8rem;
}
.h-\\[10px\\] {
  height: 10px;
}
.h-\\[14px\\] {
  height: 14px;
}
.h-\\[15px\\] {
  height: 15px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[1em\\] {
  height: 1em;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[360px\\] {
  height: 360px;
}
.h-\\[372px\\] {
  height: 372px;
}
.h-\\[3px\\] {
  height: 3px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[5rem\\] {
  height: 5rem;
}
.h-\\[600px\\] {
  height: 600px;
}
.h-\\[70vh\\] {
  height: 70vh;
}
.h-auto {
  height: auto;
}
.h-fluid-2xl {
  height: clamp(1.5rem, 1.25vw + 1.1rem, 1.75rem);
}
.h-fluid-icon-md {
  height: clamp(1.275rem, 1.1vw, 1.425rem);
}
.h-fluid-icon-sm {
  height: clamp(0.875rem, 1.1vw, 1.125rem);
}
.h-fluid-icon-xl {
  height: clamp(1.5rem, 1.75vw, 2rem);
}
.h-fluid-icon-xs {
  height: clamp(0.875rem, 1.1vw, 1.125rem);
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[1000px\\] {
  max-height: 1000px;
}
.max-h-\\[120px\\] {
  max-height: 120px;
}
.max-h-\\[18rem\\] {
  max-height: 18rem;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[20rem\\] {
  max-height: 20rem;
}
.max-h-\\[240px\\] {
  max-height: 240px;
}
.max-h-\\[24rem\\] {
  max-height: 24rem;
}
.max-h-\\[250px\\] {
  max-height: 250px;
}
.max-h-\\[360px\\] {
  max-height: 360px;
}
.max-h-\\[36vh\\] {
  max-height: 36vh;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[40rem\\] {
  max-height: 40rem;
}
.max-h-\\[40vh\\] {
  max-height: 40vh;
}
.max-h-\\[420px\\] {
  max-height: 420px;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.max-h-\\[50vh\\] {
  max-height: 50vh;
}
.max-h-\\[55vh\\] {
  max-height: 55vh;
}
.max-h-\\[60vh\\] {
  max-height: 60vh;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[78vh\\] {
  max-height: 78vh;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[95vh\\] {
  max-height: 95vh;
}
.max-h-\\[calc\\(100vh-10rem\\)\\] {
  max-height: calc(100vh - 10rem);
}
.min-h-0 {
  min-height: 0px;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[120px\\] {
  min-height: 120px;
}
.min-h-\\[2\\.5rem\\] {
  min-height: 2.5rem;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[20px\\] {
  min-height: 20px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.min-h-\\[500px\\] {
  min-height: 500px;
}
.min-h-\\[70vh\\] {
  min-height: 70vh;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[90px\\] {
  min-height: 90px;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-auto {
  width: auto !important;
}
.w-0 {
  width: 0px;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\/6 {
  width: 83.333333%;
}
.w-52 {
  width: 13rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[1\\.2em\\] {
  width: 1.2em;
}
.w-\\[1\\.8rem\\] {
  width: 1.8rem;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[10px\\] {
  width: 10px;
}
.w-\\[10rem\\] {
  width: 10rem;
}
.w-\\[14px\\] {
  width: 14px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[15px\\] {
  width: 15px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[1em\\] {
  width: 1em;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[22\\%\\] {
  width: 22%;
}
.w-\\[230px\\] {
  width: 230px;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[310px\\] {
  width: 310px;
}
.w-\\[340px\\] {
  width: 340px;
}
.w-\\[36\\%\\] {
  width: 36%;
}
.w-\\[360px\\] {
  width: 360px;
}
.w-\\[3px\\] {
  width: 3px;
}
.w-\\[4\\.5rem\\] {
  width: 4.5rem;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[420px\\] {
  width: 420px;
}
.w-\\[5rem\\] {
  width: 5rem;
}
.w-\\[800px\\] {
  width: 800px;
}
.w-\\[calc\\(100\\%\\+40px\\)\\] {
  width: calc(100% + 40px);
}
.w-\\[clamp\\(100px\\2c 15vw\\2c 160px\\)\\] {
  width: clamp(100px,15vw,160px);
}
.w-\\[clamp\\(10rem\\2c 12vw\\2c 8rem\\)\\] {
  width: clamp(10rem,12vw,8rem);
}
.w-\\[clamp\\(120px\\2c 12vw\\2c 160px\\)\\] {
  width: clamp(120px,12vw,160px);
}
.w-\\[clamp\\(12rem\\2c 15vw\\2c 16rem\\)\\] {
  width: clamp(12rem,15vw,16rem);
}
.w-\\[clamp\\(14rem\\2c 30vw\\2c 20rem\\)\\] {
  width: clamp(14rem,30vw,20rem);
}
.w-\\[clamp\\(160px\\2c 16vw\\2c 220px\\)\\] {
  width: clamp(160px,16vw,220px);
}
.w-\\[clamp\\(180px\\2c 15vw\\2c 220px\\)\\] {
  width: clamp(180px,15vw,220px);
}
.w-\\[clamp\\(2\\.5rem\\2c 5vw\\2c 3\\.5rem\\)\\] {
  width: clamp(2.5rem,5vw,3.5rem);
}
.w-\\[clamp\\(22rem\\2c 28vw\\2c 26rem\\)\\] {
  width: clamp(22rem,28vw,26rem);
}
.w-\\[clamp\\(26rem\\2c 32vw\\2c 30rem\\)\\] {
  width: clamp(26rem,32vw,30rem);
}
.w-\\[clamp\\(3\\.5rem\\2c 5vw\\2c 5rem\\)\\] {
  width: clamp(3.5rem,5vw,5rem);
}
.w-\\[clamp\\(30rem\\2c 45vw\\2c 38rem\\)\\] {
  width: clamp(30rem,45vw,38rem);
}
.w-\\[clamp\\(72px\\2c 10vw\\2c 110px\\)\\] {
  width: clamp(72px,10vw,110px);
}
.w-\\[clamp\\(7rem\\2c 10vw\\2c 9rem\\)\\] {
  width: clamp(7rem,10vw,9rem);
}
.w-\\[min\\(36rem\\2c calc\\(100vw-2\\.5rem\\)\\)\\] {
  width: min(36rem,calc(100vw - 2.5rem));
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-fluid-2xl {
  width: clamp(1.5rem, 1.25vw + 1.1rem, 1.75rem);
}
.w-fluid-button {
  width: clamp(10rem, 14vw, 12rem);
}
.w-fluid-icon-md {
  width: clamp(1.275rem, 1.1vw, 1.425rem);
}
.w-fluid-icon-sm {
  width: clamp(0.875rem, 1.1vw, 1.125rem);
}
.w-fluid-icon-xl {
  width: clamp(1.5rem, 1.75vw, 2rem);
}
.w-fluid-icon-xs {
  width: clamp(0.875rem, 1.1vw, 1.125rem);
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.w-screen {
  width: 100vw;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.min-w-\\[10rem\\] {
  min-width: 10rem;
}
.min-w-\\[11\\.5rem\\] {
  min-width: 11.5rem;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[16rem\\] {
  min-width: 16rem;
}
.min-w-\\[220px\\] {
  min-width: 220px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[250px\\] {
  min-width: 250px;
}
.min-w-\\[280px\\] {
  min-width: 280px;
}
.min-w-\\[3\\.5rem\\] {
  min-width: 3.5rem;
}
.min-w-\\[300px\\] {
  min-width: 300px;
}
.min-w-\\[320px\\] {
  min-width: 320px;
}
.min-w-\\[4\\.5rem\\] {
  min-width: 4.5rem;
}
.min-w-\\[60px\\] {
  min-width: 60px;
}
.min-w-\\[80px\\] {
  min-width: 80px;
}
.min-w-\\[85px\\] {
  min-width: 85px;
}
.min-w-\\[clamp\\(7rem\\2c 10vw\\2c 8rem\\)\\] {
  min-width: clamp(7rem,10vw,8rem);
}
.min-w-\\[clamp\\(8rem\\2c 12vw\\2c 10rem\\)\\] {
  min-width: clamp(8rem,12vw,10rem);
}
.min-w-\\[clamp\\(8rem\\2c 8vw\\2c 10rem\\)\\] {
  min-width: clamp(8rem,8vw,10rem);
}
.min-w-full {
  min-width: 100%;
}
.max-w-0 {
  max-width: 0px;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[14rem\\] {
  max-width: 14rem;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[30rem\\] {
  max-width: 30rem;
}
.max-w-\\[320px\\] {
  max-width: 320px;
}
.max-w-\\[32rem\\] {
  max-width: 32rem;
}
.max-w-\\[360px\\] {
  max-width: 360px;
}
.max-w-\\[42rem\\] {
  max-width: 42rem;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[620px\\] {
  max-width: 620px;
}
.max-w-\\[75vw\\] {
  max-width: 75vw;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[90vw\\] {
  max-width: 90vw;
}
.max-w-\\[950px\\] {
  max-width: 950px;
}
.max-w-\\[95vw\\] {
  max-width: 95vw;
}
.max-w-\\[9rem\\] {
  max-width: 9rem;
}
.max-w-\\[clamp\\(18rem\\2c 30vw\\2c 26rem\\)\\] {
  max-width: clamp(18rem,30vw,26rem);
}
.max-w-\\[clamp\\(200px\\2c 30vw\\2c 400px\\)\\] {
  max-width: clamp(200px,30vw,400px);
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-\\[0_0_auto\\] {
  flex: 0 0 auto;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.table-auto {
  table-layout: auto;
}
.table-fixed {
  table-layout: fixed;
}
.border-collapse {
  border-collapse: collapse;
}
.border-separate {
  border-collapse: separate;
}
.border-spacing-0 {
  --tw-border-spacing-x: 0px;
  --tw-border-spacing-y: 0px;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.origin-center {
  transform-origin: center;
}
.origin-top-right {
  transform-origin: top right;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[1\\.5rem\\] {
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[40\\%\\] {
  --tw-translate-y: -40%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5 {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[0\\.5rem\\] {
  --tw-translate-x: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-4 {
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-2px\\] {
  --tw-translate-y: -2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-gpu {
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: translateY(-5px);
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1.5s infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes radiate {

  0% {
    box-shadow: 0 0 0 0 rgba(34, 54, 136, 0.7);
    transform: scale(1);
  }

  70% {
    box-shadow: 0 0 0 20px rgba(34, 54, 136, 0);
    transform: scale(1.2);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(34, 54, 136, 0);
    transform: scale(1);
  }
}
.animate-radiate {
  animation: radiate 1.5s infinite ease-out;
}
@keyframes slide-in {

  from {
    transform: translateX(100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.animate-slide-in {
  animation: slide-in 0.3s ease-out;
}
@keyframes slideUp {

  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-slide-up {
  animation: slideUp 0.3s ease-out;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1.5s linear infinite;
}
.cursor-col-resize {
  cursor: col-resize;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-wait {
  cursor: wait;
}
.touch-none {
  touch-action: none;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.select-all {
  -webkit-user-select: all;
          user-select: all;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.snap-start {
  scroll-snap-align: start;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.grid-cols-\\[120px_1fr_1fr\\] {
  grid-template-columns: 120px 1fr 1fr;
}
.grid-cols-\\[1fr\\2c 1fr\\2c 1fr\\] {
  grid-template-columns: 1fr 1fr 1fr;
}
.grid-cols-\\[2fr_1fr_auto\\] {
  grid-template-columns: 2fr 1fr auto;
}
.grid-cols-\\[44px_170px\\] {
  grid-template-columns: 44px 170px;
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(170px\\2c 170px\\)\\)\\] {
  grid-template-columns: repeat(auto-fill,minmax(170px,170px));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-\\[0\\.25rem\\] {
  gap: 0.25rem;
}
.gap-\\[0\\.3rem\\] {
  gap: 0.3rem;
}
.gap-\\[clamp\\(0\\.5rem\\2c 1cqw\\2c 1rem\\)\\] {
  gap: clamp(0.5rem,1cqw,1rem);
}
.gap-fluid-0\\.5 {
  gap: clamp(0.15rem, 0.12vw, 0.350rem);
}
.gap-fluid-1 {
  gap: clamp(0.300rem, 0.1vw, 0.350rem);
}
.gap-fluid-1\\.5 {
  gap: clamp(0.550rem, 0.480vw, 0.7rem);
}
.gap-fluid-2 {
  gap: clamp(0.625rem, 0.6vw, 0.875rem);
}
.gap-fluid-2\\.5 {
  gap: clamp(0.75rem, 0.75vw, 1.05rem);
}
.gap-fluid-3 {
  gap: clamp(0.875rem, 0.9vw, 1.25rem);
}
.gap-fluid-4 {
  gap: clamp(1.5rem, 2.5vw, 2.5rem);
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-x-fluid-2 {
  column-gap: clamp(0.625rem, 0.6vw, 0.875rem);
}
.gap-x-fluid-3 {
  column-gap: clamp(0.875rem, 0.9vw, 1.25rem);
}
.gap-x-fluid-4 {
  column-gap: clamp(1.5rem, 2.5vw, 2.5rem);
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-fluid-2 {
  row-gap: clamp(0.625rem, 0.6vw, 0.875rem);
}
.gap-y-fluid-3 {
  row-gap: clamp(0.875rem, 0.9vw, 1.25rem);
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-fluid-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(clamp(0.300rem, 0.1vw, 0.350rem) * var(--tw-space-x-reverse));
  margin-left: calc(clamp(0.300rem, 0.1vw, 0.350rem) * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-fluid-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(clamp(0.625rem, 0.6vw, 0.875rem) * var(--tw-space-x-reverse));
  margin-left: calc(clamp(0.625rem, 0.6vw, 0.875rem) * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.space-y-fluid-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(clamp(0.15rem, 0.12vw, 0.350rem) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(clamp(0.15rem, 0.12vw, 0.350rem) * var(--tw-space-y-reverse));
}
.space-y-fluid-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(clamp(0.300rem, 0.1vw, 0.350rem) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(clamp(0.300rem, 0.1vw, 0.350rem) * var(--tw-space-y-reverse));
}
.space-y-fluid-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(clamp(0.550rem, 0.480vw, 0.7rem) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(clamp(0.550rem, 0.480vw, 0.7rem) * var(--tw-space-y-reverse));
}
.space-y-fluid-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(clamp(0.625rem, 0.6vw, 0.875rem) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(clamp(0.625rem, 0.6vw, 0.875rem) * var(--tw-space-y-reverse));
}
.space-y-fluid-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(clamp(0.875rem, 0.9vw, 1.25rem) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(clamp(0.875rem, 0.9vw, 1.25rem) * var(--tw-space-y-reverse));
}
.space-y-fluid-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(clamp(1.5rem, 2.5vw, 2.5rem) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(clamp(1.5rem, 2.5vw, 2.5rem) * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.break-keep {
  word-break: keep-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[clamp\\(0\\.75rem\\2c 1vw\\2c 1\\.5rem\\)\\] {
  border-radius: clamp(0.75rem,1vw,1.5rem);
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-md {
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-bl-sm {
  border-bottom-left-radius: 0.125rem;
}
.rounded-br-sm {
  border-bottom-right-radius: 0.125rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-l-\\[8px\\] {
  border-left-width: 8px;
}
.border-r {
  border-right-width: 1px;
}
.border-r-\\[8px\\] {
  border-right-width: 8px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-t-\\[8px\\] {
  border-top-width: 8px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-dotted {
  border-style: dotted;
}
.border-none {
  border-style: none;
}
.border-\\[\\#1B7F48\\]\\/50 {
  border-color: rgb(27 127 72 / 0.5);
}
.border-\\[\\#1e2a74\\] {
  --tw-border-opacity: 1;
  border-color: rgb(30 42 116 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1f2d6b\\] {
  --tw-border-opacity: 1;
  border-color: rgb(31 45 107 / var(--tw-border-opacity, 1));
}
.border-\\[\\#223688\\] {
  --tw-border-opacity: 1;
  border-color: rgb(34 54 136 / var(--tw-border-opacity, 1));
}
.border-\\[\\#223688\\]\\/40 {
  border-color: rgb(34 54 136 / 0.4);
}
.border-\\[\\#223688\\]\\/50 {
  border-color: rgb(34 54 136 / 0.5);
}
.border-\\[\\#C4C4C4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(196 196 196 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D0D5DD\\] {
  --tw-border-opacity: 1;
  border-color: rgb(208 213 221 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EA4335\\] {
  --tw-border-opacity: 1;
  border-color: rgb(234 67 53 / var(--tw-border-opacity, 1));
}
.border-\\[\\#b91c1c\\] {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity, 1));
}
.border-\\[\\#c7c7e6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(199 199 230 / var(--tw-border-opacity, 1));
}
.border-\\[\\#c9efd7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(201 239 215 / var(--tw-border-opacity, 1));
}
.border-\\[\\#cdd5ff\\] {
  --tw-border-opacity: 1;
  border-color: rgb(205 213 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e2e6ff\\] {
  --tw-border-opacity: 1;
  border-color: rgb(226 230 255 / var(--tw-border-opacity, 1));
}
.border-acs-primary-blue\\/30 {
  border-color: rgb(50 78 198 / 0.3);
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-300\\/80 {
  border-color: rgb(252 211 77 / 0.8);
}
.border-amber-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-blue-300\\/50 {
  border-color: rgb(147 197 253 / 0.5);
}
.border-blue-400 {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-blue-900 {
  --tw-border-opacity: 1;
  border-color: rgb(30 58 138 / var(--tw-border-opacity, 1));
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-500 {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-400 {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.border-indigo-600 {
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-indigo-700 {
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / var(--tw-border-opacity, 1));
}
.border-orange-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-pink-200 {
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity, 1));
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-red-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-600 {
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.border-teal-200 {
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/40 {
  border-color: rgb(255 255 255 / 0.4);
}
.border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-yellow-300\\/50 {
  border-color: rgb(253 224 71 / 0.5);
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-r-transparent {
  border-right-color: transparent;
}
.border-t-gray-200 {
  --tw-border-opacity: 1;
  border-top-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-t-gray-500 {
  --tw-border-opacity: 1;
  border-top-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-t-transparent {
  border-top-color: transparent;
}
.border-t-white {
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.bg-Delete-red {
  --tw-bg-opacity: 1;
  background-color: rgb(194 42 29 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e2a74\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 42 116 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#223688\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(34 54 136 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#223688\\]\\/10 {
  background-color: rgb(34 54 136 / 0.1);
}
.bg-\\[\\#223688\\]\\/20 {
  background-color: rgb(34 54 136 / 0.2);
}
.bg-\\[\\#232849\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(35 40 73 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2563eb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#31C4AB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(49 196 171 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#423A91\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(66 58 145 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#5B65A5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(91 101 165 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6DE1C2\\]\\/20 {
  background-color: rgb(109 225 194 / 0.2);
}
.bg-\\[\\#E0F2F1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E6E8F0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(230 232 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E7E7FB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 231 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E9E9F8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(233 233 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3F4F6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8FAFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F9FAFB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F9FAFE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAFAFB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAFBFC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 251 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#c63b2d\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(198 59 45 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e6e6f9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(230 230 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e6f0ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(230 240 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e7e9fb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 233 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e7f7ed\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 247 237 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e8edff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 237 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e9eafc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eafaf1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 250 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f4ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f5f5f5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f5f6fc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 246 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6f7fb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 247 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8c1bc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 193 188 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8f9ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8fafc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f9fbff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 251 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f9fffa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 255 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fafafa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fbfbfd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 251 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fde8e8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 232 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fef3c7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-acs-accent\\/20 {
  background-color: rgb(49 196 171 / 0.2);
}
.bg-acs-primary-blue {
  --tw-bg-opacity: 1;
  background-color: rgb(50 78 198 / var(--tw-bg-opacity, 1));
}
.bg-acs-primary-green {
  --tw-bg-opacity: 1;
  background-color: rgb(49 196 171 / var(--tw-bg-opacity, 1));
}
.bg-acs-primary-navy {
  --tw-bg-opacity: 1;
  background-color: rgb(33 45 105 / var(--tw-bg-opacity, 1));
}
.bg-acs-secondary-mint {
  --tw-bg-opacity: 1;
  background-color: rgb(190 227 222 / var(--tw-bg-opacity, 1));
}
.bg-acs-secondary-mint\\/70 {
  background-color: rgb(190 227 222 / 0.7);
}
.bg-acs-secondary-mint\\/80 {
  background-color: rgb(190 227 222 / 0.8);
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/45 {
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
}
.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
}
.bg-custom-bg-blue {
  --tw-bg-opacity: 1;
  background-color: rgb(30 42 116 / var(--tw-bg-opacity, 1));
}
.bg-custom-bg-light-purple {
  --tw-bg-opacity: 1;
  background-color: rgb(230 230 249 / var(--tw-bg-opacity, 1));
}
.bg-custom-bg-purple {
  background-color: #8083cf40;
}
.bg-custom-bg-purple-solid {
  --tw-bg-opacity: 1;
  background-color: rgb(128 131 207 / var(--tw-bg-opacity, 1));
}
.bg-cyan-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/60 {
  background-color: rgb(236 253 245 / 0.6);
}
.bg-emerald-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/60 {
  background-color: rgb(249 250 251 / 0.6);
}
.bg-gray-50\\/80 {
  background-color: rgb(249 250 251 / 0.8);
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/40 {
  background-color: rgb(238 242 255 / 0.4);
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-neutral-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 229 229 / var(--tw-bg-opacity, 1));
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity, 1));
}
.bg-orange-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-pink-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity, 1));
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}
.bg-red-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity, 1));
}
.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-sky-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(125 211 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-900\\/30 {
  background-color: rgb(15 23 42 / 0.3);
}
.bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}
.bg-teal-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(153 246 228 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/25 {
  background-color: rgb(255 255 255 / 0.25);
}
.bg-white\\/60 {
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-90 {
  --tw-bg-opacity: 0.9;
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#1A2454\\] {
  --tw-gradient-from: #1A2454 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(26 36 84 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-acs-primary-green {
  --tw-gradient-from: #31C4AB var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(49 196 171 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-acs-primary-green\\/10 {
  --tw-gradient-from: rgb(49 196 171 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(49 196 171 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-acs-primary-navy {
  --tw-gradient-from: #212D69 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(33 45 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-acs-secondary-mint\\/70 {
  --tw-gradient-from: rgb(190 227 222 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(190 227 222 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-100 {
  --tw-gradient-from: #fef3c7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 243 199 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-acs-primary-blue\\/30 {
  --tw-gradient-to: rgb(50 78 198 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(50 78 198 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#0D1332\\] {
  --tw-gradient-to: #0D1332 var(--tw-gradient-to-position);
}
.to-acs-primary-blue {
  --tw-gradient-to: #324EC6 var(--tw-gradient-to-position);
}
.to-gray-50 {
  --tw-gradient-to: #f9fafb var(--tw-gradient-to-position);
}
.to-orange-50 {
  --tw-gradient-to: #fff7ed var(--tw-gradient-to-position);
}
.to-teal-400 {
  --tw-gradient-to: #2dd4bf var(--tw-gradient-to-position);
}
.to-teal-50 {
  --tw-gradient-to: #f0fdfa var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.fill-current {
  fill: currentColor;
}
.stroke-2 {
  stroke-width: 2;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-fluid-0\\.5 {
  padding: clamp(0.15rem, 0.12vw, 0.350rem);
}
.p-fluid-1 {
  padding: clamp(0.300rem, 0.1vw, 0.350rem);
}
.p-fluid-1\\.5 {
  padding: clamp(0.550rem, 0.480vw, 0.7rem);
}
.p-fluid-2 {
  padding: clamp(0.625rem, 0.6vw, 0.875rem);
}
.p-fluid-2\\.5 {
  padding: clamp(0.75rem, 0.75vw, 1.05rem);
}
.p-fluid-3 {
  padding: clamp(0.875rem, 0.9vw, 1.25rem);
}
.p-fluid-4 {
  padding: clamp(1.5rem, 2.5vw, 2.5rem);
}
.p-fluid-5 {
  padding: clamp(2rem, 3vw, 3rem);
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-fluid-1 {
  padding-left: clamp(0.300rem, 0.1vw, 0.350rem);
  padding-right: clamp(0.300rem, 0.1vw, 0.350rem);
}
.px-fluid-1\\.5 {
  padding-left: clamp(0.550rem, 0.480vw, 0.7rem);
  padding-right: clamp(0.550rem, 0.480vw, 0.7rem);
}
.px-fluid-2 {
  padding-left: clamp(0.625rem, 0.6vw, 0.875rem);
  padding-right: clamp(0.625rem, 0.6vw, 0.875rem);
}
.px-fluid-2\\.5 {
  padding-left: clamp(0.75rem, 0.75vw, 1.05rem);
  padding-right: clamp(0.75rem, 0.75vw, 1.05rem);
}
.px-fluid-3 {
  padding-left: clamp(0.875rem, 0.9vw, 1.25rem);
  padding-right: clamp(0.875rem, 0.9vw, 1.25rem);
}
.px-fluid-4 {
  padding-left: clamp(1.5rem, 2.5vw, 2.5rem);
  padding-right: clamp(1.5rem, 2.5vw, 2.5rem);
}
.px-fluid-5 {
  padding-left: clamp(2rem, 3vw, 3rem);
  padding-right: clamp(2rem, 3vw, 3rem);
}
.px-fluid-button-x {
  padding-left: clamp(0.75rem, 0.5vw, 1rem);
  padding-right: clamp(0.75rem, 0.5vw, 1rem);
}
.px-fluid-input-x {
  padding-left: clamp(0.75rem, 0.5vw, 1rem);
  padding-right: clamp(0.75rem, 0.5vw, 1rem);
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[0\\.15rem\\] {
  padding-top: 0.15rem;
  padding-bottom: 0.15rem;
}
.py-\\[0\\.3rem\\] {
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}
.py-\\[0\\.4rem\\] {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[clamp\\(0\\.2rem\\2c 0\\.2vw\\2c 0\\.3rem\\)\\] {
  padding-top: clamp(0.2rem,0.2vw,0.3rem);
  padding-bottom: clamp(0.2rem,0.2vw,0.3rem);
}
.py-fluid-0\\.5 {
  padding-top: clamp(0.15rem, 0.12vw, 0.350rem);
  padding-bottom: clamp(0.15rem, 0.12vw, 0.350rem);
}
.py-fluid-1 {
  padding-top: clamp(0.300rem, 0.1vw, 0.350rem);
  padding-bottom: clamp(0.300rem, 0.1vw, 0.350rem);
}
.py-fluid-1\\.5 {
  padding-top: clamp(0.550rem, 0.480vw, 0.7rem);
  padding-bottom: clamp(0.550rem, 0.480vw, 0.7rem);
}
.py-fluid-2 {
  padding-top: clamp(0.625rem, 0.6vw, 0.875rem);
  padding-bottom: clamp(0.625rem, 0.6vw, 0.875rem);
}
.py-fluid-3 {
  padding-top: clamp(0.875rem, 0.9vw, 1.25rem);
  padding-bottom: clamp(0.875rem, 0.9vw, 1.25rem);
}
.py-fluid-4 {
  padding-top: clamp(1.5rem, 2.5vw, 2.5rem);
  padding-bottom: clamp(1.5rem, 2.5vw, 2.5rem);
}
.py-fluid-button-y {
  padding-top: clamp(0.25rem, 0.35vw, 0.375rem);
  padding-bottom: clamp(0.25rem, 0.35vw, 0.375rem);
}
.py-fluid-input-y {
  padding-top: clamp(0.5rem, 0.4vw, 0.75rem);
  padding-bottom: clamp(0.5rem, 0.4vw, 0.75rem);
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-fluid-1 {
  padding-bottom: clamp(0.300rem, 0.1vw, 0.350rem);
}
.pb-fluid-2 {
  padding-bottom: clamp(0.625rem, 0.6vw, 0.875rem);
}
.pb-fluid-3 {
  padding-bottom: clamp(0.875rem, 0.9vw, 1.25rem);
}
.pb-fluid-4 {
  padding-bottom: clamp(1.5rem, 2.5vw, 2.5rem);
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pl-\\[1\\.75rem\\] {
  padding-left: 1.75rem;
}
.pl-\\[clamp\\(2rem\\2c 2vw\\+1rem\\2c 2\\.75rem\\)\\] {
  padding-left: clamp(2rem,2vw + 1rem,2.75rem);
}
.pl-fluid-2 {
  padding-left: clamp(0.625rem, 0.6vw, 0.875rem);
}
.pl-fluid-2\\.5 {
  padding-left: clamp(0.75rem, 0.75vw, 1.05rem);
}
.pl-fluid-3 {
  padding-left: clamp(0.875rem, 0.9vw, 1.25rem);
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-\\[7px\\] {
  padding-right: 7px;
}
.pr-fluid-1 {
  padding-right: clamp(0.300rem, 0.1vw, 0.350rem);
}
.pr-fluid-2 {
  padding-right: clamp(0.625rem, 0.6vw, 0.875rem);
}
.pr-fluid-3 {
  padding-right: clamp(0.875rem, 0.9vw, 1.25rem);
}
.pr-fluid-4 {
  padding-right: clamp(1.5rem, 2.5vw, 2.5rem);
}
.pr-fluid-5 {
  padding-right: clamp(2rem, 3vw, 3rem);
}
.pr-fluid-button-x {
  padding-right: clamp(0.75rem, 0.5vw, 1rem);
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-\\[clamp\\(3\\.75rem\\2c 6vw\\2c 4\\.375rem\\)\\] {
  padding-top: clamp(3.75rem,6vw,4.375rem);
}
.pt-fluid-1 {
  padding-top: clamp(0.300rem, 0.1vw, 0.350rem);
}
.pt-fluid-2 {
  padding-top: clamp(0.625rem, 0.6vw, 0.875rem);
}
.pt-fluid-3 {
  padding-top: clamp(0.875rem, 0.9vw, 1.25rem);
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-roboto {
  font-family: Inter, Roboto, -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Segoe UI", system-ui, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11\\.5px\\] {
  font-size: 11.5px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[clamp\\(4\\.5rem\\2c 14vw\\2c 7rem\\)\\] {
  font-size: clamp(4.5rem,14vw,7rem);
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-dense-base {
  font-size: clamp(0.9375rem, 0.4vw + 0.8rem, 1.125rem);
}
.text-dense-xs {
  font-size: clamp(0.75rem, 0.25vw + 0.65rem, 0.875rem);
}
.text-fluid-base {
  font-size: clamp(0.875rem, 0.35vw + 0.7rem, 1rem);
}
.text-fluid-lg {
  font-size: clamp(1rem, 0.45vw + 0.7rem, 1.125rem);
}
.text-fluid-sm {
  font-size: clamp(0.85rem, 0.25vw + 0.6rem, 0.900rem);
}
.text-fluid-xl {
  font-size: clamp(1.30rem, 0.70vw + 0.90rem, 1.375rem);
}
.text-fluid-xs {
  font-size: clamp(0.6875rem, 0.2vw + 0.58rem, 0.90rem);
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-feature-settings: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.12em\\] {
  letter-spacing: 0.12em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.text-Delete-red {
  --tw-text-opacity: 1;
  color: rgb(194 42 29 / var(--tw-text-opacity, 1));
}
.text-\\[\\#030229\\] {
  --tw-text-opacity: 1;
  color: rgb(3 2 41 / var(--tw-text-opacity, 1));
}
.text-\\[\\#085041\\] {
  --tw-text-opacity: 1;
  color: rgb(8 80 65 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0c1629\\] {
  --tw-text-opacity: 1;
  color: rgb(12 22 41 / var(--tw-text-opacity, 1));
}
.text-\\[\\#111827\\] {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1565C0\\] {
  --tw-text-opacity: 1;
  color: rgb(21 101 192 / var(--tw-text-opacity, 1));
}
.text-\\[\\#16a34a\\] {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-\\[\\#191D23\\] {
  --tw-text-opacity: 1;
  color: rgb(25 29 35 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1B7F48\\] {
  --tw-text-opacity: 1;
  color: rgb(27 127 72 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1D2939\\] {
  --tw-text-opacity: 1;
  color: rgb(29 41 57 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1e2a74\\] {
  --tw-text-opacity: 1;
  color: rgb(30 42 116 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1f2d6b\\] {
  --tw-text-opacity: 1;
  color: rgb(31 45 107 / var(--tw-text-opacity, 1));
}
.text-\\[\\#223688\\] {
  --tw-text-opacity: 1;
  color: rgb(34 54 136 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2563eb\\] {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-\\[\\#28A745\\] {
  --tw-text-opacity: 1;
  color: rgb(40 167 69 / var(--tw-text-opacity, 1));
}
.text-\\[\\#344054\\] {
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4b5563\\] {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-\\[\\#64748b\\] {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-\\[\\#92400e\\] {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-\\[\\#A0A0A0\\] {
  --tw-text-opacity: 1;
  color: rgb(160 160 160 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C62828\\] {
  --tw-text-opacity: 1;
  color: rgb(198 40 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F8FAFF\\] {
  --tw-text-opacity: 1;
  color: rgb(248 250 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#dc2626\\] {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-acs-accent {
  --tw-text-opacity: 1;
  color: rgb(49 196 171 / var(--tw-text-opacity, 1));
}
.text-acs-dark-subtext {
  --tw-text-opacity: 1;
  color: rgb(160 174 192 / var(--tw-text-opacity, 1));
}
.text-acs-dark-text {
  color: #fafafaff;
}
.text-acs-light-text {
  --tw-text-opacity: 1;
  color: rgb(12 22 41 / var(--tw-text-opacity, 1));
}
.text-acs-primary-blue {
  --tw-text-opacity: 1;
  color: rgb(50 78 198 / var(--tw-text-opacity, 1));
}
.text-acs-primary-green {
  --tw-text-opacity: 1;
  color: rgb(49 196 171 / var(--tw-text-opacity, 1));
}
.text-acs-primary-navy {
  --tw-text-opacity: 1;
  color: rgb(33 45 105 / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-amber-900\\/95 {
  color: rgb(120 53 15 / 0.95);
}
.text-amber-950 {
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-custom-bg-blue {
  --tw-text-opacity: 1;
  color: rgb(30 42 116 / var(--tw-text-opacity, 1));
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-orange-800 {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-pink-800 {
  --tw-text-opacity: 1;
  color: rgb(157 23 77 / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-teal-800 {
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.decoration-white {
  text-decoration-color: #fff;
}
.decoration-2 {
  text-decoration-thickness: 2px;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.placeholder-\\[\\#9DA8BB\\]::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(157 168 187 / var(--tw-placeholder-opacity, 1));
}
.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.accent-\\[\\#1B7F48\\] {
  accent-color: #1B7F48;
}
.accent-\\[\\#1e2a74\\] {
  accent-color: #1e2a74;
}
.accent-\\[\\#223688\\] {
  accent-color: #223688;
}
.accent-\\[\\#3b82f6\\] {
  accent-color: #3b82f6;
}
.accent-indigo-600 {
  accent-color: #4f46e5;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-90 {
  opacity: 0.9;
}
.mix-blend-normal {
  mix-blend-mode: normal;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_12px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.10\\)\\] {
  --tw-shadow: 0 0 12px rgba(0,0,0,0.10);
  --tw-shadow-colored: 0 0 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 1px 2px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\] {
  --tw-shadow: 0 1px 3px rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_rgba\\(239\\2c 68\\2c 68\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 1px 3px rgba(239,68,68,0.25);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_3px_8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\] {
  --tw-shadow: 0 3px 8px rgba(0,0,0,0.2);
  --tw-shadow-colored: 0 3px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_3px_8px_rgba\\(239\\2c 68\\2c 68\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 3px 8px rgba(239,68,68,0.25);
  --tw-shadow-colored: 0 3px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[\\#1e2a74\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 42 116 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#2563eb\\]\\/35 {
  --tw-ring-color: rgb(37 99 235 / 0.35);
}
.ring-acs-secondary-mint {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(190 227 222 / var(--tw-ring-opacity, 1));
}
.ring-amber-200\\/60 {
  --tw-ring-color: rgb(253 230 138 / 0.6);
}
.ring-black\\/5 {
  --tw-ring-color: rgb(0 0 0 / 0.05);
}
.ring-blue-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
.ring-indigo-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 180 252 / var(--tw-ring-opacity, 1));
}
.ring-indigo-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-2xl {
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm {
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-\\[1px\\] {
  --tw-backdrop-blur: blur(1px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[flex-basis\\2c transform\\2c box-shadow\\] {
  transition-property: flex-basis,transform,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\] {
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-none {
  transition-property: none;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-\\[cubic-bezier\\(0\\.4\\2c 0\\2c 0\\.2\\2c 1\\)\\] {
  transition-timing-function: cubic-bezier(0.4,0,0.2,1);
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-\\[flex-basis\\2c transform\\2c box-shadow\\] {
  will-change: flex-basis,transform,box-shadow;
}
.scrollbar::-webkit-scrollbar-track {
  background-color: var(--scrollbar-track);
  border-radius: var(--scrollbar-track-radius);
}
.scrollbar::-webkit-scrollbar-track:hover {
  background-color: var(--scrollbar-track-hover, var(--scrollbar-track));
}
.scrollbar::-webkit-scrollbar-track:active {
  background-color: var(--scrollbar-track-active, var(--scrollbar-track-hover, var(--scrollbar-track)));
}
.scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb);
  border-radius: var(--scrollbar-thumb-radius);
}
.scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-thumb-hover, var(--scrollbar-thumb));
}
.scrollbar::-webkit-scrollbar-thumb:active {
  background-color: var(--scrollbar-thumb-active, var(--scrollbar-thumb-hover, var(--scrollbar-thumb)));
}
.scrollbar::-webkit-scrollbar-corner {
  background-color: var(--scrollbar-corner);
  border-radius: var(--scrollbar-corner-radius);
}
.scrollbar::-webkit-scrollbar-corner:hover {
  background-color: var(--scrollbar-corner-hover, var(--scrollbar-corner));
}
.scrollbar::-webkit-scrollbar-corner:active {
  background-color: var(--scrollbar-corner-active, var(--scrollbar-corner-hover, var(--scrollbar-corner)));
}
.scrollbar {
  scrollbar-width: auto;
  scrollbar-color: var(--scrollbar-thumb, initial) var(--scrollbar-track, initial);
}
.scrollbar::-webkit-scrollbar {
  display: block;
  width: var(--scrollbar-width, 16px);
  height: var(--scrollbar-height, 16px);
}
.scrollbar-thin::-webkit-scrollbar-track {
  background-color: var(--scrollbar-track);
  border-radius: var(--scrollbar-track-radius);
}
.scrollbar-thin::-webkit-scrollbar-track:hover {
  background-color: var(--scrollbar-track-hover, var(--scrollbar-track));
}
.scrollbar-thin::-webkit-scrollbar-track:active {
  background-color: var(--scrollbar-track-active, var(--scrollbar-track-hover, var(--scrollbar-track)));
}
.scrollbar-thin::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb);
  border-radius: var(--scrollbar-thumb-radius);
}
.scrollbar-thin::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-thumb-hover, var(--scrollbar-thumb));
}
.scrollbar-thin::-webkit-scrollbar-thumb:active {
  background-color: var(--scrollbar-thumb-active, var(--scrollbar-thumb-hover, var(--scrollbar-thumb)));
}
.scrollbar-thin::-webkit-scrollbar-corner {
  background-color: var(--scrollbar-corner);
  border-radius: var(--scrollbar-corner-radius);
}
.scrollbar-thin::-webkit-scrollbar-corner:hover {
  background-color: var(--scrollbar-corner-hover, var(--scrollbar-corner));
}
.scrollbar-thin::-webkit-scrollbar-corner:active {
  background-color: var(--scrollbar-corner-active, var(--scrollbar-corner-hover, var(--scrollbar-corner)));
}
.scrollbar-thin {
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb, initial) var(--scrollbar-track, initial);
}
.scrollbar-thin::-webkit-scrollbar {
  display: block;
  width: 8px;
  height: 8px;
}
.scrollbar-none {
  scrollbar-width: none;
}
.scrollbar-none::-webkit-scrollbar {
  display: none;
}
.scrollbar-track-gray-100 {
  --scrollbar-track: #f3f4f6 !important;
}
.scrollbar-thumb-\\[\\#A0AEC0\\] {
  --scrollbar-thumb: #A0AEC0 !important;
}
.scrollbar-thumb-gray-300 {
  --scrollbar-thumb: #d1d5db !important;
}
.scrollbar-thumb-gray-400 {
  --scrollbar-thumb: #9ca3af !important;
}
.scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
/* globally in your styles.css or index.css */
input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  opacity: 0;
  -webkit-appearance: none;
  display: none;
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-0::after {
  content: var(--tw-content);
  inset: 0px;
}
.after\\:left-0\\.5::after {
  content: var(--tw-content);
  left: 0.125rem;
}
.after\\:top-0\\.5::after {
  content: var(--tw-content);
  top: 0.125rem;
}
.after\\:flex::after {
  content: var(--tw-content);
  display: flex;
}
.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}
.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}
.after\\:items-center::after {
  content: var(--tw-content);
  align-items: center;
}
.after\\:justify-center::after {
  content: var(--tw-content);
  justify-content: center;
}
.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:border::after {
  content: var(--tw-content);
  border-width: 1px;
}
.after\\:border-gray-300::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.first\\:pt-0:first-child {
  padding-top: 0px;
}
.last\\:mb-4:last-child {
  margin-bottom: 1rem;
}
.last\\:border-0:last-child {
  border-width: 0px;
}
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.last\\:border-none:last-child {
  border-style: none;
}
.last\\:pb-0:last-child {
  padding-bottom: 0px;
}
.odd\\:bg-white:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.even\\:bg-gray-50:nth-child(even) {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.checked\\:border-acs-checkbox:checked {
  --tw-border-opacity: 1;
  border-color: rgb(34 54 136 / var(--tw-border-opacity, 1));
}
.checked\\:bg-acs-checkbox:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(34 54 136 / var(--tw-bg-opacity, 1));
}
.checked\\:after\\:text-\\[12px\\]:checked::after {
  content: var(--tw-content);
  font-size: 12px;
}
.checked\\:after\\:font-bold:checked::after {
  content: var(--tw-content);
  font-weight: 700;
}
.checked\\:after\\:text-white:checked::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.checked\\:after\\:content-\\[\\'\\2713\\'\\]:checked::after {
  --tw-content: '✓';
  content: var(--tw-content);
}
.focus-within\\:border-blue-400:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.focus-within\\:border-blue-500:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.focus-within\\:ring-1:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-2:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-blue-400:focus-within {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
.focus-within\\:ring-blue-500:focus-within {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.focus-within\\:ring-blue-500\\/20:focus-within {
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
.group[open] .group-open\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group\\/kpi-tip:focus-within .group-focus-within\\/kpi-tip\\:visible {
  visibility: visible;
}
.group\\/kpi-tip:hover .group-hover\\/kpi-tip\\:visible {
  visibility: visible;
}
.group:hover .group-hover\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:border-\\[\\#223688\\] {
  --tw-border-opacity: 1;
  border-color: rgb(34 54 136 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:bg-\\[\\#d7d9f8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(215 217 248 / var(--tw-bg-opacity, 1));
}
.group\\/kpi-tip:hover .group-hover\\/kpi-tip\\:text-\\[\\#223688\\] {
  --tw-text-opacity: 1;
  color: rgb(34 54 136 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-\\[\\#16205c\\] {
  --tw-text-opacity: 1;
  color: rgb(22 32 92 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-\\[\\#223688\\] {
  --tw-text-opacity: 1;
  color: rgb(34 54 136 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.peer:checked ~ .peer-checked\\:translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:bg-\\[\\#1e2a74\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 42 116 / var(--tw-bg-opacity, 1));
}
.peer:checked ~ .peer-checked\\:bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.peer:checked ~ .peer-checked\\:bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.peer:checked ~ .peer-checked\\:after\\:translate-x-5::after {
  content: var(--tw-content);
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-\\[1px\\]:hover {
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.02\\]:hover {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-\\[\\#16205c\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(22 32 92 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#223688\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(34 54 136 / var(--tw-border-opacity, 1));
}
.hover\\:border-acs-primary-green:hover {
  --tw-border-opacity: 1;
  border-color: rgb(49 196 171 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#18225c\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(24 34 92 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1A2B6D\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(26 43 109 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1E2A74\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 42 116 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1a2a61\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(26 42 97 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1a2b6d\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(26 43 109 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1a2c73\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(26 44 115 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1a2d66\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(26 45 102 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1b2d6b\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(27 45 107 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1b2d74\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(27 45 116 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1c2c6d\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(28 44 109 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1d316b\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 49 107 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#223688\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(34 54 136 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2d3d99\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(45 61 153 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#6DE1C2\\]\\/30:hover {
  background-color: rgb(109 225 194 / 0.3);
}
.hover\\:bg-\\[\\#F4F6F9\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 246 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F5F6FC\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 246 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#d9d9f1\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 241 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#eef0ff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 240 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#eef1ff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 241 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f2f5ff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(242 245 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f4f5ff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 245 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f4fbf7\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 251 247 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f8f9ff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f9fbff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 251 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f9fffa\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 255 250 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-acs-dark-hover:hover {
  background-color: rgba(255,255,255,0.1);
}
.hover\\:bg-acs-primary-blue:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(50 78 198 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-100\\/80:hover {
  background-color: rgb(254 243 199 / 0.8);
}
.hover\\:bg-amber-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-opacity-80:hover {
  --tw-bg-opacity: 0.8;
}
.hover\\:bg-opacity-90:hover {
  --tw-bg-opacity: 0.9;
}
.hover\\:text-\\[\\#1B7F48\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(27 127 72 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#1a2a66\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(26 42 102 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#1a2b6d\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(26 43 109 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#1a2c73\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(26 44 115 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#1b2c7a\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(27 44 122 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#1e2a74\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(30 42 116 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#223688\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(34 54 136 / var(--tw-text-opacity, 1));
}
.hover\\:text-acs-accent:hover {
  --tw-text-opacity: 1;
  color: rgb(49 196 171 / var(--tw-text-opacity, 1));
}
.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-900:hover {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.hover\\:text-green-600:hover {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-600:hover {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.hover\\:text-orange-600:hover {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-800:hover {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.hover\\:opacity-90:hover {
  opacity: 0.9;
}
.hover\\:shadow-2xl:hover {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:border-\\[\\#1e2a74\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(30 42 116 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[\\#223688\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(34 54 136 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.focus\\:border-transparent:focus {
  border-color: transparent;
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[\\#1e2a74\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 42 116 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#223688\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 54 136 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#223688\\]\\/30:focus {
  --tw-ring-color: rgb(34 54 136 / 0.3);
}
.focus\\:ring-acs-accent:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(49 196 171 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-acs-primary-green:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(49 196 171 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(22 163 74 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(220 38 38 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-white\\/60:focus {
  --tw-ring-color: rgb(255 255 255 / 0.6);
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:bg-\\[\\#16225e\\]:active {
  --tw-bg-opacity: 1;
  background-color: rgb(22 34 94 / var(--tw-bg-opacity, 1));
}
.active\\:shadow-inner:active {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:cursor-wait:disabled {
  cursor: wait;
}
.disabled\\:bg-gray-100:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-gray-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.disabled\\:opacity-30:disabled {
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
.disabled\\:opacity-70:disabled {
  opacity: 0.7;
}
.dark\\:divide-acs-dark-border:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(46 49 56 / var(--tw-divide-opacity, 1));
}
.dark\\:border-\\[\\#295c45\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(41 92 69 / var(--tw-border-opacity, 1));
}
.dark\\:border-\\[\\#30456f\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(48 69 111 / var(--tw-border-opacity, 1));
}
.dark\\:border-\\[\\#3B5CCC\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(59 92 204 / var(--tw-border-opacity, 1));
}
.dark\\:border-\\[\\#3a3d44\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(58 61 68 / var(--tw-border-opacity, 1));
}
.dark\\:border-\\[\\#5d6fc0\\]\\/50:is(.dark *) {
  border-color: rgb(93 111 192 / 0.5);
}
.dark\\:border-acs-accent:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(49 196 171 / var(--tw-border-opacity, 1));
}
.dark\\:border-acs-dark-border:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(46 49 56 / var(--tw-border-opacity, 1));
}
.dark\\:border-acs-dark-surface:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(26 28 35 / var(--tw-border-opacity, 1));
}
.dark\\:border-amber-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.dark\\:border-amber-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(180 83 9 / var(--tw-border-opacity, 1));
}
.dark\\:border-blue-500\\/40:is(.dark *) {
  border-color: rgb(59 130 246 / 0.4);
}
.dark\\:border-blue-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.dark\\:border-red-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.dark\\:border-red-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity, 1));
}
.dark\\:border-red-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}
.dark\\:border-red-900:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(127 29 29 / var(--tw-border-opacity, 1));
}
.dark\\:border-yellow-500\\/40:is(.dark *) {
  border-color: rgb(234 179 8 / 0.4);
}
.dark\\:bg-\\[\\#14151a\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(20 21 26 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#1E293B\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#1F2128\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 33 40 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#1a1c23\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(26 28 35 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#1c2438\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(28 36 56 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#1f1f29\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 31 41 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#1f2a25\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 42 37 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#22242B\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(34 36 43 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#22368833\\]:is(.dark *) {
  background-color: #22368833;
}
.dark\\:bg-\\[\\#223688\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(34 54 136 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#223688\\]\\/25:is(.dark *) {
  background-color: rgb(34 54 136 / 0.25);
}
.dark\\:bg-\\[\\#223688\\]\\/30:is(.dark *) {
  background-color: rgb(34 54 136 / 0.3);
}
.dark\\:bg-\\[\\#23262d\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(35 38 45 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#2A2D35\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(42 45 53 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#31C4AB\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(49 196 171 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#31C4AB\\]\\/10:is(.dark *) {
  background-color: rgb(49 196 171 / 0.1);
}
.dark\\:bg-\\[\\#31C4AB\\]\\/20:is(.dark *) {
  background-color: rgb(49 196 171 / 0.2);
}
.dark\\:bg-\\[\\#3B5CCC\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(59 92 204 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#3B5CCC\\]\\/25:is(.dark *) {
  background-color: rgb(59 92 204 / 0.25);
}
.dark\\:bg-\\[\\#6DE1C2\\]\\/20:is(.dark *) {
  background-color: rgb(109 225 194 / 0.2);
}
.dark\\:bg-acs-accent:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(49 196 171 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-acs-accent\\/30:is(.dark *) {
  background-color: rgb(49 196 171 / 0.3);
}
.dark\\:bg-acs-dark-bg:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(13 17 23 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-acs-dark-bg\\/60:is(.dark *) {
  background-color: rgb(13 17 23 / 0.6);
}
.dark\\:bg-acs-dark-border:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(46 49 56 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-acs-dark-hover:is(.dark *) {
  background-color: rgba(255,255,255,0.1);
}
.dark\\:bg-acs-dark-surface:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(26 28 35 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-acs-dark-surface\\/90:is(.dark *) {
  background-color: rgb(26 28 35 / 0.9);
}
.dark\\:bg-acs-primary-blue\\/25:is(.dark *) {
  background-color: rgb(50 78 198 / 0.25);
}
.dark\\:bg-acs-primary-navy-dark:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(8 27 51 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-amber-400:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-amber-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-amber-900\\/30:is(.dark *) {
  background-color: rgb(120 53 15 / 0.3);
}
.dark\\:bg-amber-900\\/40:is(.dark *) {
  background-color: rgb(120 53 15 / 0.4);
}
.dark\\:bg-amber-950\\/40:is(.dark *) {
  background-color: rgb(69 26 3 / 0.4);
}
.dark\\:bg-black\\/30:is(.dark *) {
  background-color: rgb(0 0 0 / 0.3);
}
.dark\\:bg-black\\/40:is(.dark *) {
  background-color: rgb(0 0 0 / 0.4);
}
.dark\\:bg-black\\/70:is(.dark *) {
  background-color: rgb(0 0 0 / 0.7);
}
.dark\\:bg-blue-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-blue-500\\/20:is(.dark *) {
  background-color: rgb(59 130 246 / 0.2);
}
.dark\\:bg-blue-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-blue-900\\/20:is(.dark *) {
  background-color: rgb(30 58 138 / 0.2);
}
.dark\\:bg-blue-900\\/30:is(.dark *) {
  background-color: rgb(30 58 138 / 0.3);
}
.dark\\:bg-blue-900\\/40:is(.dark *) {
  background-color: rgb(30 58 138 / 0.4);
}
.dark\\:bg-cyan-900\\/40:is(.dark *) {
  background-color: rgb(22 78 99 / 0.4);
}
.dark\\:bg-emerald-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-emerald-900\\/40:is(.dark *) {
  background-color: rgb(6 78 59 / 0.4);
}
.dark\\:bg-gray-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-700\\/40:is(.dark *) {
  background-color: rgb(55 65 81 / 0.4);
}
.dark\\:bg-gray-700\\/50:is(.dark *) {
  background-color: rgb(55 65 81 / 0.5);
}
.dark\\:bg-gray-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-green-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-green-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-green-900\\/30:is(.dark *) {
  background-color: rgb(20 83 45 / 0.3);
}
.dark\\:bg-green-900\\/40:is(.dark *) {
  background-color: rgb(20 83 45 / 0.4);
}
.dark\\:bg-indigo-900\\/40:is(.dark *) {
  background-color: rgb(49 46 129 / 0.4);
}
.dark\\:bg-neutral-700\\/40:is(.dark *) {
  background-color: rgb(64 64 64 / 0.4);
}
.dark\\:bg-orange-700\\/60:is(.dark *) {
  background-color: rgb(194 65 12 / 0.6);
}
.dark\\:bg-purple-900\\/20:is(.dark *) {
  background-color: rgb(88 28 135 / 0.2);
}
.dark\\:bg-purple-900\\/40:is(.dark *) {
  background-color: rgb(88 28 135 / 0.4);
}
.dark\\:bg-red-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-red-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-red-900\\/30:is(.dark *) {
  background-color: rgb(127 29 29 / 0.3);
}
.dark\\:bg-red-900\\/40:is(.dark *) {
  background-color: rgb(127 29 29 / 0.4);
}
.dark\\:bg-red-950:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(69 10 10 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-rose-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-sky-900\\/40:is(.dark *) {
  background-color: rgb(12 74 110 / 0.4);
}
.dark\\:bg-sky-900\\/50:is(.dark *) {
  background-color: rgb(12 74 110 / 0.5);
}
.dark\\:bg-slate-900\\/40:is(.dark *) {
  background-color: rgb(15 23 42 / 0.4);
}
.dark\\:bg-teal-900\\/40:is(.dark *) {
  background-color: rgb(19 78 74 / 0.4);
}
.dark\\:bg-violet-900\\/40:is(.dark *) {
  background-color: rgb(76 29 149 / 0.4);
}
.dark\\:bg-yellow-500\\/20:is(.dark *) {
  background-color: rgb(234 179 8 / 0.2);
}
.dark\\:bg-yellow-900\\/40:is(.dark *) {
  background-color: rgb(113 63 18 / 0.4);
}
.dark\\:from-acs-dark-surface:is(.dark *) {
  --tw-gradient-from: #1A1C23 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(26 28 35 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:from-amber-950\\/80:is(.dark *) {
  --tw-gradient-from: rgb(69 26 3 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(69 26 3 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:to-acs-dark-bg:is(.dark *) {
  --tw-gradient-to: #0d1117 var(--tw-gradient-to-position);
}
.dark\\:to-orange-950\\/50:is(.dark *) {
  --tw-gradient-to: rgb(67 20 7 / 0.5) var(--tw-gradient-to-position);
}
.dark\\:text-\\[\\#1A1C23\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(26 28 35 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#31C4AB\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(49 196 171 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#37d266\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(55 210 102 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#3B5CCC\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(59 92 204 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#5d6fc0\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(93 111 192 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#6DE1C2\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(109 225 194 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#9FB4FF\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(159 180 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#F8FAFF\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 250 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-acs-accent:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(49 196 171 / var(--tw-text-opacity, 1));
}
.dark\\:text-acs-dark-subtext:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(160 174 192 / var(--tw-text-opacity, 1));
}
.dark\\:text-acs-dark-surface:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(26 28 35 / var(--tw-text-opacity, 1));
}
.dark\\:text-acs-dark-text:is(.dark *) {
  color: #fafafaff;
}
.dark\\:text-amber-100\\/90:is(.dark *) {
  color: rgb(254 243 199 / 0.9);
}
.dark\\:text-amber-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-50:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 251 235 / var(--tw-text-opacity, 1));
}
.dark\\:text-black:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.dark\\:text-custom-bg-blue:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(30 42 116 / var(--tw-text-opacity, 1));
}
.dark\\:text-cyan-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.dark\\:text-indigo-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / var(--tw-text-opacity, 1));
}
.dark\\:text-purple-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.dark\\:text-sky-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(186 230 253 / var(--tw-text-opacity, 1));
}
.dark\\:text-sky-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity, 1));
}
.dark\\:text-teal-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(153 246 228 / var(--tw-text-opacity, 1));
}
.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-yellow-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 240 138 / var(--tw-text-opacity, 1));
}
.dark\\:text-yellow-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}
.dark\\:text-yellow-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.dark\\:placeholder-acs-dark-subtext:is(.dark *)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(160 174 192 / var(--tw-placeholder-opacity, 1));
}
.dark\\:placeholder-gray-500:is(.dark *)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}
.dark\\:shadow-\\[0_1px_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\]:is(.dark *) {
  --tw-shadow: 0 1px 3px rgba(0,0,0,0.2);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dark\\:shadow-\\[0_3px_8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\]:is(.dark *) {
  --tw-shadow: 0 3px 8px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0 3px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dark\\:ring-acs-accent:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(49 196 171 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-acs-dark-border:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(46 49 56 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-acs-primary-blue\\/40:is(.dark *) {
  --tw-ring-color: rgb(50 78 198 / 0.4);
}
.dark\\:ring-amber-900\\/40:is(.dark *) {
  --tw-ring-color: rgb(120 53 15 / 0.4);
}
.dark\\:brightness-200:is(.dark *) {
  --tw-brightness: brightness(2);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.dark\\:scrollbar-track-\\[\\#1A1C23\\]:is(.dark *) {
  --scrollbar-track: #1A1C23 !important;
}
.dark\\:scrollbar-thumb-\\[\\#3b5bdb\\]:is(.dark *) {
  --scrollbar-thumb: #3b5bdb !important;
}
.dark\\:checked\\:border-acs-checkbox-dark:checked:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(59 91 219 / var(--tw-border-opacity, 1));
}
.dark\\:checked\\:bg-acs-checkbox-dark:checked:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(59 91 219 / var(--tw-bg-opacity, 1));
}
.dark\\:focus-within\\:border-\\[\\#223688\\]:focus-within:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(34 54 136 / var(--tw-border-opacity, 1));
}
.dark\\:focus-within\\:ring-\\[\\#223688\\]:focus-within:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 54 136 / var(--tw-ring-opacity, 1));
}
.dark\\:hover\\:border-\\[\\#223688\\]:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(34 54 136 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:border-blue-500:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:border-red-500:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#1A2B6D\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(26 43 109 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#1E2A74\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 42 116 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#1f222a\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 34 42 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#223688\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(34 54 136 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#223688\\]\\/20:hover:is(.dark *) {
  background-color: rgb(34 54 136 / 0.2);
}
.dark\\:hover\\:bg-\\[\\#27b099\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(39 176 153 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#2A2D35\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(42 45 53 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#4C6EE7\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(76 110 231 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-acs-accent\\/80:hover:is(.dark *) {
  background-color: rgb(49 196 171 / 0.8);
}
.dark\\:hover\\:bg-acs-dark-border:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(46 49 56 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-acs-dark-border\\/80:hover:is(.dark *) {
  background-color: rgb(46 49 56 / 0.8);
}
.dark\\:hover\\:bg-acs-dark-hover:hover:is(.dark *) {
  background-color: rgba(255,255,255,0.1);
}
.dark\\:hover\\:bg-acs-dark-hover\\/40:hover:is(.dark *) {
  background-color: rgba(255, 255, 255, 0.4);
}
.dark\\:hover\\:bg-acs-primary-green\\/20:hover:is(.dark *) {
  background-color: rgb(49 196 171 / 0.2);
}
.dark\\:hover\\:bg-amber-900\\/30:hover:is(.dark *) {
  background-color: rgb(120 53 15 / 0.3);
}
.dark\\:hover\\:bg-blue-400:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-blue-900:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-emerald-400:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-400:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-green-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-green-900\\/30:hover:is(.dark *) {
  background-color: rgb(20 83 45 / 0.3);
}
.dark\\:hover\\:bg-green-900\\/60:hover:is(.dark *) {
  background-color: rgb(20 83 45 / 0.6);
}
.dark\\:hover\\:bg-purple-900\\/30:hover:is(.dark *) {
  background-color: rgb(88 28 135 / 0.3);
}
.dark\\:hover\\:bg-red-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-red-900\\/20:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}
.dark\\:hover\\:bg-red-900\\/30:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.3);
}
.dark\\:hover\\:bg-red-900\\/40:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.4);
}
.dark\\:hover\\:bg-red-950\\/30:hover:is(.dark *) {
  background-color: rgb(69 10 10 / 0.3);
}
.dark\\:hover\\:bg-rose-400:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:text-\\[\\#223688\\]:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(34 54 136 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-\\[\\#3B5CCC\\]:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(59 92 204 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-\\[\\#8290d0\\]:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(130 144 208 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-acs-accent:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(49 196 171 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-acs-dark-hover:hover:is(.dark *) {
  color: rgba(255,255,255,0.1);
}
.dark\\:hover\\:text-acs-dark-text:hover:is(.dark *) {
  color: #fafafaff;
}
.dark\\:hover\\:text-blue-100:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-blue-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-blue-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-gray-200:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-gray-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-gray-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-green-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-orange-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-red-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-white:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-yellow-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.hover\\:dark\\:text-acs-dark-text:is(.dark *):hover {
  color: #fafafaff;
}
.dark\\:focus\\:border-acs-dark-hover:focus:is(.dark *) {
  border-color: rgba(255,255,255,0.1);
}
.dark\\:focus\\:ring-\\[\\#31C4AB\\]:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(49 196 171 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-\\[\\#3B5CCC\\]:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 92 204 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-acs-accent:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(49 196 171 / var(--tw-ring-opacity, 1));
}
.dark\\:active\\:bg-\\[\\#16225e\\]:active:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(22 34 94 / var(--tw-bg-opacity, 1));
}
@media (min-width: 640px) {

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }

  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:min-h-\\[300px\\] {
    min-height: 300px;
  }

  .sm\\:w-40 {
    width: 10rem;
  }

  .sm\\:max-w-\\[90\\%\\] {
    max-width: 90%;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }

  .sm\\:translate-x-\\[1rem\\] {
    --tw-translate-x: 1rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:translate-y-0 {
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:scale-100 {
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:scale-95 {
    --tw-scale-x: .95;
    --tw-scale-y: .95;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[18\\%_32\\%_20\\%_30\\%\\] {
    grid-template-columns: 18% 32% 20% 30%;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .sm\\:border-l {
    border-left-width: 1px;
  }

  .sm\\:border-t-0 {
    border-top-width: 0px;
  }

  .sm\\:p-0 {
    padding: 0px;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-fluid-3 {
    padding-left: clamp(0.875rem, 0.9vw, 1.25rem);
    padding-right: clamp(0.875rem, 0.9vw, 1.25rem);
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:pr-2 {
    padding-right: 0.5rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-fluid-sm {
    font-size: clamp(0.85rem, 0.25vw + 0.6rem, 0.900rem);
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .sm\\:leading-7 {
    line-height: 1.75rem;
  }
}
@media (min-width: 768px) {

  .md\\:absolute {
    position: absolute;
  }

  .md\\:relative {
    position: relative;
  }

  .md\\:right-6 {
    right: 1.5rem;
  }

  .md\\:top-6 {
    top: 1.5rem;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .md\\:ml-\\[50\\%\\] {
    margin-left: 50%;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-40 {
    width: 10rem;
  }

  .md\\:w-80 {
    width: 20rem;
  }

  .md\\:w-\\[22rem\\] {
    width: 22rem;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:max-w-\\[800px\\] {
    max-width: 800px;
  }

  .md\\:max-w-none {
    max-width: none;
  }

  .md\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:px-fluid-1 {
    padding-left: clamp(0.300rem, 0.1vw, 0.350rem);
    padding-right: clamp(0.300rem, 0.1vw, 0.350rem);
  }

  .md\\:px-fluid-4 {
    padding-left: clamp(1.5rem, 2.5vw, 2.5rem);
    padding-right: clamp(1.5rem, 2.5vw, 2.5rem);
  }

  .md\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:text-right {
    text-align: right;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .lg\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .lg\\:max-w-\\[1000px\\] {
    max-width: 1000px;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .lg\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
}
@media (min-width: 1280px) {

  .xl\\:max-w-\\[1200px\\] {
    max-width: 1200px;
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[12\\%_33\\%_20\\%_35\\%\\] {
    grid-template-columns: 12% 33% 20% 35%;
  }
}
@media (min-width: 1440px) {

  .\\32xl\\:max-w-\\[1400px\\] {
    max-width: 1400px;
  }
}
@media (min-width: 360px) {

  .xs\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .xs\\:w-36 {
    width: 9rem;
  }

  .xs\\:max-w-\\[85vw\\] {
    max-width: 85vw;
  }

  .xs\\:flex-row {
    flex-direction: row;
  }

  .xs\\:space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }

  .xs\\:p-5 {
    padding: 1.25rem;
  }

  .xs\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .xs\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.\\[\\&\\>td\\]\\:py-1\\.5>td {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&\\>td\\]\\:py-2>td {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.\\[\\&\\>td\\]\\:text-\\[11px\\]>td {
  font-size: 11px;
}
@media (min-width: 640px) {

  .sm\\:\\[\\&\\>td\\]\\:text-sm>td {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:\\[\\&\\>td\\]\\:text-xs>td {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (min-width: 768px) {

  .md\\:\\[\\&\\>td\\]\\:text-sm>td {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.\\[\\&\\[data-state\\=open\\]\\]\\:scale-100[data-state=open] {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\]\\:opacity-100[data-state=open] {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,mQAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd;AAAc;EAAd;IAAA,8CAAc;EAAA;;EAAd,kCAAc;EAAd;IAAA;MAAA,+CAAc;IAAA;EAAA;;EAAd,yBAAc;EAAd;IAAA;MAAA,8CAAc;IAAA;EAAA;;EAAd;IAAA;MAAA,mCAAc;MAAd,kCAAc;MAAd,oBAAc;IAAA;EAAA;;EAAd,6BAAc;EAAd;IAAA;MAAA,0CAAc;IAAA;EAAA;;EAAd,0BAAc;EAAd;IAAA;MAAA,+CAAc;IAAA;EAAA;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,wBAAmB;IAAnB;EAAmB;;EAAnB;IAAA,2BAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,0CAAmB;IAAnB;EAAmB;;EAAnB;IAAA,2CAAmB;IAAnB;EAAmB;;EAAnB;IAAA,wCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,wBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gFAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gFAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wFAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wFAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wFAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wFAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oFAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,6IAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB,UAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAkDjB;IACE,wBAAwB;IACxB,qBAAqB;;IAErB;MACE,aAAa;IACf;EACF;AAMA,6CAA6C;AAC/C;EACE,UAAU;EACV,wBAAwB;EACxB,aAAa;AACf;AAtEA;EAAA,0BAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA,wBAwGA;EAxGA,wDAwGA;EAxGA;AAwGA;AAxGA;EAAA,gBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,iBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,2GAwGA;EAxGA,yGAwGA;EAxGA;AAwGA;AAxGA;EAAA,2GAwGA;EAxGA,yGAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,mBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,eAwGA;EAxGA,eAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,0BAwGA;EAxGA,yBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,iBAwGA;EAxGA,iBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,gDAwGA;EAxGA,6DAwGA;EAxGA;AAwGA;AAxGA;EAAA,+EAwGA;EAxGA,mGAwGA;EAxGA;AAwGA;AAxGA;EAAA,6EAwGA;EAxGA,iGAwGA;EAxGA;AAwGA;AAxGA;EAAA,gFAwGA;EAxGA,oGAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,8BAwGA;EAxGA;AAwGA;AAxGA;EAAA,2GAwGA;EAxGA,yGAwGA;EAxGA;AAwGA;AAxGA;EAAA,2GAwGA;EAxGA,yGAwGA;EAxGA;AAwGA;AAxGA;EAAA,2GAwGA;EAxGA,yGAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,iBAwGA;EAxGA,iBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,gDAwGA;EAxGA,6DAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,4DAwGA;EAxGA,kEAwGA;EAxGA;AAwGA;AAxGA;EAAA,uEAwGA;EAxGA,iEAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,2BAwGA;EAxGA;AAwGA;AAxGA;EAAA,2BAwGA;EAxGA;AAwGA;AAxGA;EAAA,sCAwGA;EAxGA,qDAwGA;EAxGA;AAwGA;AAxGA;EAAA,sCAwGA;EAxGA,qDAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,8BAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,sBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,oBAwGA;EAxGA;AAwGA;AAxGA;EAAA,kBAwGA;EAxGA;AAwGA;AAxGA;;EAAA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA,sBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,qBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,eAwGA;IAxGA,eAwGA;IAxGA;EAwGA;;EAxGA;IAAA,iBAwGA;IAxGA,iBAwGA;IAxGA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA,uBAwGA;IAxGA,4DAwGA;IAxGA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA,sBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,qBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,kBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,6CAwGA;IAxGA;EAwGA;;EAxGA;IAAA,mBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,oBAwGA;IAxGA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA,iBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,eAwGA;IAxGA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA,mBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,kBAwGA;IAxGA;EAwGA;;EAxGA;IAAA;EAwGA;AAAA;AAxGA;;EAAA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA,qBAwGA;IAxGA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA,iBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,oBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,oBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,kBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,8CAwGA;IAxGA;EAwGA;;EAxGA;IAAA,0CAwGA;IAxGA;EAwGA;;EAxGA;IAAA,mBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,iBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,mBAwGA;IAxGA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA,iBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,eAwGA;IAxGA;EAwGA;;EAxGA;IAAA,mBAwGA;IAxGA;EAwGA;AAAA;AAxGA;;EAAA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;AAAA;AAxGA;;EAAA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;AAAA;AAxGA;;EAAA;IAAA;EAwGA;AAAA;AAxGA;;EAAA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA,uBAwGA;IAxGA,+DAwGA;IAxGA;EAwGA;;EAxGA;IAAA;EAwGA;;EAxGA;IAAA,iBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,mBAwGA;IAxGA;EAwGA;AAAA;AAxGA;EAAA,qBAwGA;EAxGA;AAwGA;AAxGA;EAAA,mBAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA;AAxGA;;EAAA;IAAA,mBAwGA;IAxGA;EAwGA;;EAxGA;IAAA,kBAwGA;IAxGA;EAwGA;AAAA;AAxGA;;EAAA;IAAA,mBAwGA;IAxGA;EAwGA;AAAA;AAxGA;EAAA,eAwGA;EAxGA,eAwGA;EAxGA;AAwGA;AAxGA;EAAA;AAwGA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  :root {\n    font-size: clamp(9.0px, 0.6vw + 0.45rem, 10px);\n  }\n\n  /* Laptop screens: 1025px–1440px */\n  @media (min-width: 1025px) and (max-width: 1440px) {\n    :root {\n      font-size: clamp(11px, 0.75vw + 0.5rem, 12.5px);\n    }\n  }\n  \n  /* Big screens: 1441px+ */\n  @media (min-width: 1441px) {\n    :root {\n      font-size: clamp(12px, 0.8vw + 0.5rem, 13.5px);\n    }\n  }\n\n  @supports (font: -apple-system-body) {\n    body {\n      -webkit-font-smoothing: antialiased;\n      text-rendering: optimizeLegibility;\n      font-synthesis: none;\n    }\n  }\n\n  /* Mobile-first adjustments */\n  @media (max-width: 640px) {\n    :root {\n      font-size: clamp(12px, 0.7vw + 13px, 13px);\n    }\n  }\n\n  /* High-DPI optimization */\n  @media (-webkit-device-pixel-ratio: 1.25) {\n    :root {\n      font-size: clamp(10.5px, 0.75vw + 0.5rem, 12px);\n    }\n  }\n}\n\n@layer utilities {\n  .min-tap-target {\n    min-inline-size: clamp(44px, 4vw, 48px);\n    min-block-size: clamp(44px, 4vw, 48px);\n  }\n\n  .scrollbar-hide {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  .scrollbar-gutter-stable {\n    scrollbar-gutter: stable;\n  }\n\n  /* globally in your styles.css or index.css */\ninput[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n  opacity: 0;\n  -webkit-appearance: none;\n  display: none;\n}\n\n\n  .pixel-optimized {\n    image-rendering: crisp-edges;\n    image-rendering: -webkit-optimize-contrast;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: -o-crisp-edges;\n    image-rendering: pixelated;\n    -ms-interpolation-mode: nearest-neighbor;\n  }\n\n  .density-compensate {\n    transform: scale(var(--tw-fluid-scale, 1));\n    transform-origin: left top;\n  }\n  \n  .container-view {\n    container-type: inline-size;\n    width: min(100%, 1600px);\n    margin: 0 auto;\n  }\n  \n  .high-contrast {\n    forced-color-adjust: none;\n    -ms-high-contrast-adjust: none;\n    \n    @media (forced-colors: active) {\n      border-color: CanvasText !important;\n      background-color: Canvas !important;\n      color: CanvasText !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
